module.exports = {
  platform: 'voice',
  name: 'Stamp service',
  node: 'stamp_service',
  bg: '#FFFFFF',
  note: '',
  property: {
    service_name: 'Stamp service',
    service_type: 'self-service',
    status: 'unknown',
    sub_status: '',
    remark: '',
    metadata: '',
    create_checkpoint: false
  }
}
